import { SelectContentEvent } from '@moonpig/web-core-analytics'

export const ProductDetailsTabClickGAEvent = (
  tabName: string,
  productId: string,
): SelectContentEvent => {
  return {
    event: 'select_content',
    event_data: {
      category: 'product details',
      action: 'view item',
      label: `product details | ${productId.toLowerCase()} | tab | ${tabName.toLocaleLowerCase()}`,
      non_interaction: true,
      value: undefined,
    },
  }
}
